const Util = require('~/utils/util')
const CONS = require('~/constant').default
const queries = Util.getUrlParams()

Util.setXWRefer()
Util.setXWActFrom()

module.exports = {
  queries,
  Browser: Util.checkPlatform(),
  Util,
  CONS
}
